<template>
    <div class="newsBg">
        <div class="newsMain">
            <div class="help-content">
                <div class="menu">
                    <ul>
                        <li @click="menuIndex = index" :class="[index == menuIndex ? 'active' : '']"
                            v-for="(item, index) in  menus" :key="index">{{
                                item }}</li>
                    </ul>
                </div>
                <div class="content">
                    <template v-if="menuIndex == 0">
                        <h2>Vae+ APP平台介绍</h2>
                        <p>“Vae+ APP”是一款专为许嵩粉丝设计的官方应用程序。自2016年以来，一直是许嵩全球歌迷会、VaeCn、百度许嵩吧以及官方微博的延续和发展。</p>
                        <p>Vae+ APP 功能简介：</p>
                        <p>首首页资讯: 集中显示所有关于许嵩的最新官方新闻资讯，包括新闻、专访、图集和视频，还特别置顶许嵩的帖子，让用户轻松查看。 </p>
                        <p>
                            最新动态: 用户可以查看许嵩的最新官方演出行程，并通过点击“我要报名”参与其中。还可以设置活动提醒。
                        </p>
                        <p>
                            互动社区: 圈子广场设有多个频道与话题，用户可在此发帖与其他歌迷朋友互动，并关注感兴趣的人，以查看他们的最新动态。
                        </p>
                        <p>
                            附近的人和商城: 在发现页面，用户不仅可以查看附近的歌迷朋友，还可以浏览和积分兑换官方周边产品。
                        </p>
                        <p>
                            消息推送: 用户会接收到官方消息、@我的、聊天信息和帖子评论、点赞的推送。
                        </p>
                        <p>
                            个人主页: 在这里，用户可以查看自己的等级、经验、积分和人气等信息，并通过达成成就来兑换勋章。
                        </p>
                        <p>
                            卡通形象“许老师”: 提供语音问候和歌曲演唱功能，增添趣味性。
                        </p>
                        <p>Vae+ APP不仅是一个交互应用程序，更是许嵩与歌迷之间情感沟通的专属桥梁。Vae+里还有很多好玩功能等待你的解锁，请入驻APP一探究竟吧。在这里，我们因为一个人，爱上一群人！</p>
                    </template>
                    <template v-if="menuIndex == 1">
                        <h2>联系我们</h2>
                        <p>联系邮箱：<a href="mailto:vaestudio@hotmail.com">vaestudio@hotmail.com</a></p>
                    </template>
                    <template v-if="menuIndex == 2">
                        <h2>平台管理制度</h2>
                        <p>第一条 根据《网络音视频信息服务管理规定》，特制定本管理制度。</p>
                        <p>第二条 我公司深圳太乐文化科技有限公司旗下Vae+ APP（以下称本平台）为用户提供网络音视频信息服务，为网络音视频信息服务提供者。</p>
                        <p>第三条 本平台和平台用户必须遵守宪法、法律和行政法规，坚持正确政治方向、舆论导向和价值取向，弘扬社会主义核心价值观，促进形成积极健康、向上向善的网络文化。</p>
                        <p>第四条 本平台接受社会监督，并定期开展培训提高从业人员职业素养，促进行业健康有序发展。</p>
                        <p>第五条
                            本平台已落实信息内容安全管理主体责任，满足服务规模相适应的专业人员，建立健全用户注册、信息发布审核、信息安全管理、应急处置、从业人员教育培训、未成年人保护、知识产权保护等制度，具有与新技术新应用发展相适应的安全可控的技术保障和防范措施。
                        </p>
                        <p>第六条 本平台制定应急安全管理方案，可以有效应对网络安全事件，防范网络违法犯罪活动，维护网络数据的完整性、安全性和可用性。</p>
                        <p>第七条 使用本平台的用户必须提供身份证件号码、移动电话号码等材料进行实名认证，未进行实名认证得用户无法使用本平台得服务。</p>
                        <p>第八条 网站发布信息必须履行严格的审批手续，未经领导批准，不得随意发布。</p>
                        <p>第九条
                            本平台承诺不利用网络音视频信息服务以及相关信息技术从事危害国家安全、破坏社会稳定、扰乱社会秩序、侵犯他人合法权益等法律法规禁止的活动，不得制作、发布、传播煽动颠覆国家政权、危害政治安全和社会稳定、网络谣言、淫秽色情，以及侵害他人名誉权、肖像权、隐私权、知识产权和其他合法权益等法律法规禁止的信息内容。
                        </p>
                        <p>第十条
                            网站管理员要严格遵循岗位职责，要有高度的社会责任感和强烈的工作责任心，确保网站信息发布及时、准确、公证、客观，并力求网站内容丰富。负责公司网站的内容更新，包括网站各类资料的收集、整理、汇总、发布。未经公司主管领导同意或批准，网站管理员不得擅自改动网站主界面。日常要保证公司网站的正常运营，若发现网站运行出现异常，要及时采取有效措施。网站遭到恶意攻击和破坏时，网站管理员应及时向主管领导汇报情况，共同做好不就与维护。
                        </p>
                        <p>第十一条 网站内容审核</p>
                        <p>1、公司自审人员对本公司的音乐作品的审核，音乐里不得有暴力、赌博、淫秽等内容。</p>
                        <p>音乐部分不得有任何国歌、宗教等类型音乐。</p>
                        <p>音乐：</p>
                        <p>（1）音乐作品来源拥有著作权和/或依法可以行使著作权的权属证明。</p>
                        <p>（2）引用他人的词，曲，伴奏（填词，歌曲改编等）进行二度创作的确保音乐作品是参与创作或者有相关版权人授权，以免引起不必要的纠纷。</p>
                        <p>（3）根据法律规定使用他人著作，如作者过世超过50年的，指明作者姓名、作品名称可以为原创（古诗词等）。</p>
                        <p>（4）正确完整且积极向上的歌曲的内容信息（词，曲，唱，编曲，缩混等）全方面审查，歌词及歌曲信息中严禁涉及政治，广告，色情，暴力等违规内容。</p>
                        <p>2、自审经营活动</p>
                        <p>（1）提供服务时，保证用户使用有效身份证件进行注册。</p>
                        <p>（2）接到利害关系人、政府部门、司法机关通知后，协助审核交易行为的合法性。</p>
                        <p>（3）根据法律法规或者服务协议停止为音乐提供服务的，提前告知用户并说明理由。</p>
                        <p>（4）发现音乐用户发布违法信息的，依照法律规定或者服务协议立即停止为其提供服务，保存相关记录并向有关部门报告。</p>
                        <p>（5）不为违法经营音乐活动提供网上支付服务。</p>
                        <p>（6）按照国家规定采取技术和管理措施保证网络信息安全，包括防止计算机病毒入侵和攻击破坏，备份重要数据库，保存用户注册信息、运营信息、维护日志等信息，依法保护国家秘密、商业秘密和用户个人信息。
                        </p>
                        <p>3、所有审核记录保存两年。</p>
                    </template>
                    <template v-if="menuIndex == 3">
                        <h2>纠纷处理制度</h2>
                        <p>深圳太乐文化科技有限公司（以下简称"本公司"）经营Vae+ APP。前述平台中包含众多用户上传的信息、第三方发布的信息以及其他来自互联网的信息。</p>

                        <p>本公司为保护著作权人的合法权利，根据我国相关法律法规的规定，将通过以下途径保护秀动网网站内作品的著作权：</p>

                        <p>“作品”是指受《中华人民共和国著作权法》保护的文学、艺术和科学作品，包括但不限于文字作品、美术作品、表演、录音录像制品等。</p>

                        <p>“权利人”是指作品的著作权人或者经著作权人合法授权而享有作品的信息网络传播权的权利享有人。</p>

                        <p>·通知程序</p>
                        <p>权利人认为本公司经营的网站中相关信息、搜索或链接的内容所涉及的作品侵犯了其信息网络传播权或者被删除、改变了自己的权利管理电子信息的，可向成都太合乐动科技有限公司提交书面通知，要求删除该作品，或者断开该作品的链接。通知书需权利人亲笔签名，若为单位则需加盖单位公章。
                        </p>
                        <p>·通知书需要包含下列内容</p>
                        <p>（一） 权利人的姓名（名称）、联系方式、地址、身份证复印件（自然人）、单位登记证明复印件（单位）；</p>
                        <p>（二） 要求删除或者断开链接的侵权作品的准确名称和网络地址；</p>
                        <p>（三） 认为构成侵权的初步证明材料，包括但不限于对作品享有著作权或依法享有信息网络传播权的权属证明、创作手稿、经权威机构签发的作品创作时间戳、作品备案证书、列举证据证明侵权事实。</p>
                        <p>权利人应对通知书的真实性负责。若通知书的内容不真实，权利人将承担由此造成的全部法律责任。</p>
                        <p>本公司收到权利人的通知及完整的证明材料后，将立即删除涉嫌侵权的作品，或者断开涉嫌侵权作品的链接。</p>
                        <p>·反通知程序</p>
                        <p>本公司将投诉通知到作品提供者，若内容提供者认为作品不侵权的可提供相关证据反通知到成都太合乐动科技有限公司。反通知书需作品提供者亲笔签名，若为单位则需加盖单位公章。</p>
                        <p>·用户交易纠纷的处理方式</p>
                        <p>1、本公司仅作为本网站的运营商，如若与本网站用户之间发生纠纷且无法协商一致的，可向司法机关寻求解决，包括但不限于向公安机关报案、申请仲裁或向人民法院提起诉讼等。本公司将会为实名注册用户提供必要的协助和支持，并根据有关司法机关的要求承担一定的举证责任或采取必要措施。
                        </p>
                        <p> 2、本网站用户之间发生纠纷的，也可向本公司的纠纷联系人投诉并举证。用户需提供与其账号注册信息一致的个人有效身份证件、必要的司法机关文件和其他本公司要求提供的相关证据。经本公司审核确认后，可以给予必要的协助和支持。
                        </p>
                        <p> 3、如本网站用户对本公司的服务有任何异议的，可以向本公司的客服人员投诉并举证。查证属实的，本公司将立即更正并按照现行法律规定给予用户必要的补偿。</p>
                        <p>·用户交易纠纷处理的工作流程</p>
                        <p>1.在公司网站显要位置公布投诉处理电话、电子邮箱、通讯地址，并指定专人负责客户投诉处理。</p>
                        <p> 2.认真且及时处理用户的投诉和意见，及时向用户反馈处理结果，并做好记录。</p>
                        <p>3.用户交易纠纷经协商无法解决时，可向相关部门申诉，或通过法律程序解决。</p>
                        <p>4. 本公司会采取必要的措施和申诉处理程序措施保障用户的合法权益，用户在充值会员的使用过程中出现纠纷的，应出示与所注册的身份信息相一致的个人有效身份证件。在核实用户身份后，按照申诉处理程序处理
                        </p>

                    </template>
                    <template v-if="menuIndex == 4">
                        <h2>内容审核制度</h2>
                        <p>本制度旨在规范本公司网络文化作品及服务内容（包括但不限于作品宣传推广，活动策划）的自审工作，明确本企业按照《网络文化经营单位内容自审管理办法》开展相关工作的职责、流程、标准以及责任追究办法。
                        </p>

                        <p>1、审核标准</p>
                        <p>我公司自审人员对本公司的音乐作品的审核，音乐里不得有暴力、赌博、淫秽等内容。音乐部分不得有任何国歌、宗教等类型音乐。</p>
                        <p>（1）音乐作品来源拥有著作权和/或依法可以行使著作权的权属证明。</p>
                        <p>（2）引用他人的词，曲，伴奏（填词，歌曲改编等）进行二度创作的确保音乐作品是参与创作或者有相关版权人授权，以免引起不必要的纠纷。</p>
                        <p>（3）根据法律规定使用他人著作，如作者过世超过50年的，指明作者姓名、作品名称可以为原创（古诗词等）。</p>
                        <p>（4）正确完整且积极向上的歌曲的内容信息（词，曲，唱，编曲，缩混等）全方面审查，歌词及歌曲信息中严禁涉及政治，广告，色情，暴力等违规内容。</p>

                        <p>2、自审经营活动</p>
                        <p>（1）提供服务时，保证用户使用有效身份证件进行注册。</p>
                        <p>（2）接到利害关系人、政府部门、司法机关通知后，协助审核交易行为的合法性。</p>
                        <p>（3）根据法律法规或者服务协议停止为音乐提供服务的，提前告知用户并说明理由。</p>
                        <p>（4）发现音乐用户发布违法信息的，依照法律规定或者服务协议立即停止为其提供服务，保存相关记录并向有关部门报告。</p>
                        <p>（5）不为违法经营音乐活动提供网上支付服务。</p>
                        <p>（6）按照国家规定采取技术和管理措施保证网络信息安全，包括防止计算机病毒入侵和攻击破坏，备份重要数据库，保存用户注册信息、运营信息、维护日志等信息，依法保护国家秘密、商业秘密和用户个人信息。
                        </p>

                        <p>3、内容自审部门组织架构</p>
                        <p> 公司成立独立于各个业务部门的内容审查小组，并采取培训上岗，小组成员包括技术开发总监、客服部主管、投诉部总监以及运营部总监。由公司总经理负责自审小组的召集和日常运作事宜。自审小组的主要任务是在产品开发过程中规范相关产品内容；在版本验收环节对可能涉及违反法律法规的内容进行自查自纠；在产品运营过程中随时检查各种营销素材、营销活动及其他内容是否有不适当的内容出现。并且一旦发现有违规情况的发生，自审小组负责对相关责任人和部门进行查处惩戒。
                        </p>
                        <p>培训：进行企业文化，企业产品和音乐平台规范的培训，培训结束后，进行考核，考核未通过不允许进入内容审查小组。</p>
                        <p>管理：严格把关视频、聊天、社区内容等审核机制，全面抵制网上淫秽色情信息，坚持以严肃认真的态度，全面履行社会责任。建立落实信息安全管理制度，杜绝淫秽色情信息的传播。</p>

                        <p>4、审查人员职责</p>
                        <p>（1）本公司审核部门人员均掌握内容审核的政策法规和相关知识。</p>
                        <p>（2）在任何情况下，审核人员均可在内容自审这一工作表达其独立的审核意见。</p>
                        <p>（3）审核人员须以最终保证本企业的作品和服务的合法性和合规性为目的，对在自审工作中发现违规的作品及服务内容进行记录关提请中止，作出提交修改、督促修改、复审等审核意见。重大问题向主管部门报告。
                        </p>
                        <p>（4）审核人员负责保管审查记录。</p>
                        <p>（5）审核人员遇到有对作品及服务内容的合法合规性不能准确判断的，需向主管部门咨询或申请指导。</p>
                        <p>（6）审核人员将定期参加文化局组织的相关业务培圳。</p>
                        <p>（7）审核人员有组织内部培圳工作，对企业版权负责人员、运营人员进行内容审查方面的培圳的责任。</p>

                        <p> 5、内容自审流程</p>
                        <p>（1）对本公司自主创作的作品，在创作阶段进行培圳；对故事背景，美术素材、歌词、曲风等进行初步筛查。</p>
                        <p>（2）审核人员在作品发布前，依据内容审查的相关规定，对作品及服务内容（包括宣传推广，活动策划）进行审查，对违法违规内容进行记录，并签发初审意见。</p>
                        <p>（3）对初审有问题的作品，退回相关部门进行修改，并对修改后的内容进行复查。</p>
                        <p>（4）对内容的合法合规性不能准确判断的，向主管部门咨询、请教和学习。</p>
                        <p>（5）复查仍有问题的，按照上述2-4所规定内容重新进行审核。</p>
                        <p>（6）在作品发布前，对音乐作品内容进行审查，审查内容包括版权、词曲内容、实名注册、实名信息补填、用户协议必条款、不得有暴力、赌博、淫秽、适龄提示等内容，合格后方可发布。</p>
                        <p>（7）对审查完成的作品，自审人员提出同意进行发布的意见并签字确认，上交内容审查管理工作的主要负责人。</p>
                        <p>（8）日常对作品和服务内容进行监督检查，包括新的音乐引进和音乐的内容审查、公司官网、宣传推广和活动策划等各个方面和环节，发现问题提交检查意见，报本企业内容审查管理工作的主要负责人。
                        </p>
                        <p> （9）审核人员的所有审查意见应归档留存，保存时间不低于两年。</p>

                        <p>6、公司内部责任追究</p>
                        <p>（1）对审查员未能在审查中发现问题的，予以警告处置，多次出现相同这一状况，取消其审查员资格。</p>
                        <p>（2）对审查员发现问题，但开发人员拒不修改的，予以警告处置，并通报其上级主管。</p>
                        <p> （3）对审查员发现问题，但开发人员修改，审查通过后自行予以恢复的，予以严重警告处置，通报其上级主管，并处以罚款若干。</p>
                        <p>（4）以运营人员在运营过程中未通知审查员，造成不良后果，而审查员也未及时发现的，予以涉事双方警告处置，责成改正。</p>
                        <p>（5）其他情形造甩不良后果的，予以警告处置，并通报其上级主管，保留进一步追责的权力。</p>

                    </template>
                    <template v-if="menuIndex == 5">
                        <h2>未成年人保护制度</h2>
                        <p>我们非常重视对未成年人个人信息的保护。根据相关法律法规的规定，若您是18周岁以下的未成年人，在使用Vae+的产品或服务前，应事先取得您的家长或法定监护人的同意。若您是未成年人的监护人，当您对您所监护的未成年人的个人信息有相关疑问时，请通过下列联系方式与我们联系。
                        </p>
                        <p>1. 未满十四周岁的未成人年禁止在本平台注册。</p>
                        <p>2. 年满十四周岁但未满十八周岁的注册后属于青少年账号。青少年账号限制，畅听时间超过两小时后，自动下线，间隔八小时后才能再次上线畅听音乐。</p>
                        <p>3. 保护青少年网民的健康成长、建设绿色清朗的网络空间，开辟举报便捷通道，广大网友和社会各界可以监督支持，共同抵制网上低俗不良之风。</p>
                    </template>
                    <template v-if="menuIndex == 6">
                        <h2>会员退款</h2>
                        <p>退款说明及适用范围</p>
                        <p>会员交易纠纷指已购买使用“Vae+” VIP付费音乐服务的注册用户（亦称“会员”）后产生实际扣费且非付费人主观意愿下的交易行为（例：未成年人误开通等）</p>
                        <p>退款流程及方式</p>
                        <p>客服联系方式：<a href="mailto:vaestudio@hotmail.com">vaestudio@hotmail.com</a></p>
                        <p>注：我们将根据您的具体情况核实并处理退款诉求。（如退款审核通过，相关款项将于三个工作日内退还至原支付渠道）</p>
                    </template>
                    <template v-if="menuIndex == 7">
                        <h2>服务条款</h2>
                        <p>特别提示</p>
                        <p>深圳太乐文化科技有限公司（以下简称"太乐文化"）在此特别提醒您（用户）在注册成为用户之前，请认真阅读本《Vae+用户许可及服务协议》（以下简称"协议"），确保您充分理解本协议中各条款。请您审慎阅读并选择接受或不接受本协议。除非您接受本协议所有条款，否则您无权注册、登录或使用本协议所涉服务。您的注册、登录、使用等行为将视为对本协议的接受，并同意接受本协议各项条款的约束。
                            本协议约定太乐文化与用户之间关于"Vae+"软件服务（以下简称"服务"）的权利义务。"用户"是指注册、登录、使用本服务的个人。本协议可由太乐文化随时更新，更新后的协议条款一旦公布即代替原来的协议条款，恕不再另行通知，用户可在本网站查阅最新版协议条款。在太乐文化修改协议条款后，如果用户不接受修改后的条款，请立即停止使用太乐文化提供的服务，用户继续使用太乐文化提供的服务将被视为接受修改后的协议。
                        </p>
                        <p>一、帐号注册 </p>
                        <p> 1、用户在使用本服务前需要注册一个"Vae+"帐号。"Vae+"帐号应当使用手机号码绑定注册，请用户使用尚未与"Vae+"帐号绑定的手机号码，以及未被太乐文化根据本协议封禁的手机号码注册"Vae+"帐号。太乐文化可以根据用户需求或产品需要对帐号注册和绑定的方式进行变更，而无须事先通知用户。
                            <br />2、鉴于"Vae+"帐号的绑定注册方式，您同意太乐文化在注册时将使用您提供的手机号码及/或自动提取您的手机号码及自动提取您的手机设备识别码等信息用于注册。
                            <br />3、在用户注册及使用本服务时，太乐文化需要搜集能识别用户身份的个人信息以便太乐文化可以在必要时联系用户，或为用户提供更好的使用体验。太乐文化搜集的信息包括但不限于用户的姓名、性别、年龄、出生日期、地址、兴趣爱好、个人说明；太乐文化同意对这些信息的使用将受限于第三条用户个人隐私信息保护的约束。
                        </p>
                        <p> 二、服务内容 </p>
                        <p>本服务的具体内容由太乐文化根据实际情况提供，包括但不限于授权用户通过其帐号进行即时通讯、添加好友、加入群组、关注他人、私信、线下线上活动报名、发布、浏览、评论。太乐文化可以对其提供的服务予以变更，且太乐文化提供的服务内容可能随时变更；用户将会收到太乐文化关于服务变更的通知。
                        </p>
                        <p>三、用户个人隐私信息保护 </p>
                        <p>1、用户在注册帐号或使用本服务的过程中，可能需要填写或提交一些必要的信息，如法律法规、规章规范性文件（以下称"法律法规"）规定的需要填写的身份信息。如用户提交的信息不完整或不符合法律法规的规定，则用户可能无法使用本服务或在使用本服务的过程中受到限制。
                            <br />2、个人隐私信息是指涉及用户个人身份或个人隐私的信息，比如，用户真实姓名、身份证号、手机号码、手机设备识别码、IP地址、用户聊天记录。非个人隐私信息是指用户对本服务的操作状态以及使用习惯等明确且客观反映在太乐文化服务器端的基本记录信息、个人隐私信息范围外的其它普通信息，以及用户同意公开的上述隐私信息。
                            <br />3、尊重用户个人隐私信息的私有性是太乐文化的一贯制度，太乐文化将采取技术措施和其他必要措施，确保用户个人隐私信息安全，防止在本服务中收集的用户个人隐私信息泄露、毁损或丢失。在发生前述情形或者太乐文化发现存在发生前述情形的可能时，将及时采取补救措施。
                            <br />4、你发布音视频时，我们会请求你授权相机、照片、麦克风等敏感权限。你如果拒绝授权提供，将无法使用此功能，但不影响你正常使用Vae+的其他功能。
                            <br />5、你发布音视频等信息并选择显示位置时，我们会请求你授权地理位置这一敏感权限，并收集与本服务相关的位置信息。这些信息包括IP地址、GPS以及能够提供相关信息的WLAN等传感器技术。你如果拒绝授权提供，将无法使用此功能，但不影响你正常使用Vae+的其他功能。
                            <br />6、当您发布短视频等信息或进行直播时，我们会请求你授权存储权限，用于上传、下载内容资源。你如果拒绝授权提供，将无法使用此功能，但不影响你正常使用“Vae+”的其他功能。
                            <br />7、你发布音视频等信息，Vae+官方有权直接进行内容的平台共享，如发布在微博@许嵩全球歌迷后援会、微信“许嵩全球歌迷会”、抖音“许嵩全球歌迷会”等官方矩阵平台以及部分合作平台。但我们承诺将只共享您发布的音视频及基本信息，对于您的个人敏感信息我们将严格保密。
                            <br />8、太乐文化未经用户同意不向任何第三方公开、 透露用户个人隐私信息。但以下特定情形除外：
                            <br />(1) 太乐文化根据法律法规规定或有权机关的指示提供用户的个人隐私信息；
                            <br />(2) 由于用户将其用户密码告知他人或与他人共享注册帐户与密码，由此导致的任何个人信息的泄漏，或其他非因太乐文化原因导致的个人隐私信息的泄露；
                            <br />(3) 用户自行向第三方公开其个人隐私信息；
                            <br />(4) 用户与太乐文化及合作单位之间就用户个人隐私信息的使用公开达成约定，太乐文化因此向合作单位公开用户个人隐私信息；
                            <br />(5) 任何由于黑客攻击、电脑病毒侵入及其他不可抗力事件导致用户个人隐私信息的泄露。
                            <br /> 9、用户同意太乐文化可在以下事项中使用用户的个人隐私信息：
                            <br />(1) 太乐文化向用户及时发送重要通知，如软件更新、本协议条款的变更；
                            <br />(2) 太乐文化内部进行审计、数据分析和研究等，以改进太乐文化的产品、服务和与用户之间的沟通；
                            <br />(3) 依本协议约定，太乐文化管理、审查用户信息及进行处理措施；
                            <br />(4) 适用法律法规规定的其他事项。
                            <br /> 除上述事项外，如未取得用户事先同意，太乐文化不会将用户个人隐私信息使用于任何其他用途。
                            <br />10、太乐文化重视对未成年人个人隐私信息的保护。太乐文化将依赖用户提供的个人信息判断用户是否为未成年人。任何18岁以下的未成年人注册帐号或使用本服务应事先取得家长或其法定监护人（以下简称"监护人"）的书面同意。除根据法律法规的规定及有权机关的指示披露外，太乐文化不会使用或向任何第三方透露未成年人的聊天记录及其他个人隐私信息。除本协议约定的例外情形外，未经监护人事先同意，太乐文化不会使用或向任何第三方透露未成年人的个人隐私信息。任何18岁以下的用户不得下载和使用Vae+。
                            <br />11、为了改善太乐文化的技术和服务，向用户提供更好的服务体验，太乐文化或可会自行收集使用或向第三方提供用户的非个人隐私信息。
                        </p>
                        <p> 四、内容规范 </p>
                        <p> 1、本条所述内容是指用户使用本服务过程中所制作、上载、复制、发布、传播的任何内容，包括但不限于帐号头像、名称、用户说明等注册信息及认证资料，或文字、语音、图片、视频、图文等发送、回复和相关链接页面，以及其他使用帐号或本服务所产生的内容。
                            <br />2、用户不得利用"Vae+"帐号或本服务制作、上载、复制、发布、传播如下法律、法规和政策禁止的内容：
                            <br />(1) 反对宪法所确定的基本原则的；
                            <br />(2) 危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；
                            <br />(3) 损害国家荣誉和利益的；
                            <br />(4) 煽动民族仇恨、民族歧视，破坏民族团结的；
                            <br />(5) 破坏国家宗教政策，宣扬邪教和封建迷信的；
                            <br />(6) 散布谣言，扰乱社会秩序，破坏社会稳定的；
                            <br />(7) 散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；
                            <br /> (8) 侮辱或者诽谤他人，侵害他人合法权益的；
                            <br />(9) 不遵守法律法规底线、社会主义制度底线、国家利益底线、公民合法权益底线、社会公共秩序底线、道德风尚底线和信息真实性底线的"七条底线"要求的；
                            <br />(10) 含有法律、行政法规禁止的其他内容的信息。
                            <br /> 3、用户不得利用"Vae+"帐号或本服务制作、上载、复制、发布、传播如下干扰"Vae+"正常运营，以及侵犯其他用户或第三方合法权益的内容：
                            <br />(1) 含有任何性或性暗示的；
                            <br /> (2) 含有辱骂、恐吓、威胁内容的；
                            <br />(3) 含有骚扰、垃圾广告、恶意信息、诱骗信息的；
                            <br /> (4) 涉及他人隐私、个人信息或资料的；
                            <br /> (5) 侵害他人名誉权、肖像权、知识产权、商业秘密等合法权利的；
                            <br />(6) 含有其他干扰本服务正常运营和侵犯其他用户或第三方合法权益内容的信息。
                        </p>
                        <p>五、使用规则 </p>
                        <p>1、用户在本服务中或通过本服务所传送、发布的任何内容并不反映或代表，也不得被视为反映或代表太乐文化的观点、立场或政策，太乐文化对此不承担任何责任。
                            <br /> 2、用户不得利用"Vae+"帐号或本服务进行如下行为：
                            <br /> (1) 提交、发布虚假信息，或盗用他人头像或资料，冒充、利用他人名义的；
                            <br />(2) 强制、诱导其他用户关注、点击链接页面或分享信息的；
                            <br /> (3) 虚构事实、隐瞒真相以误导、欺骗他人的；
                            <br />(4) 利用技术手段批量建立虚假帐号的；
                            <br /> (5) 利用"Vae+"帐号或本服务从事任何违法犯罪活动的；
                            <br />(6) 制作、发布与以上行为相关的方法、工具，或对此类方法、工具进行运营或传播，无论这些行为是否为商业目的；
                            <br /> (7) 其他违反法律法规规定、侵犯其他用户合法权益、干扰"Vae+"正常运营或太乐文化未明示授权的行为。
                            <br />
                            3、用户须对利用"Vae+"帐号或本服务传送信息的真实性、合法性、无害性、准确性、有效性等全权负责，与用户所传播的信息相关的任何法律责任由用户自行承担，与太乐文化无关。如因此给太乐文化或第三方造成损害的，用户应当依法予以赔偿。
                            <br />
                            4、太乐文化提供的服务中可能包括广告，用户同意在使用过程中显示太乐文化和第三方供应商、合作伙伴提供的广告。除法律法规明确规定外，用户应自行对依该广告信息进行的交易负责，对用户因依该广告信息进行的交易或前述广告商提供的内容而遭受的损失或损害，太乐文化不承担任何责任。
                        </p>
                        <p> 六、账户管理 </p>
                        <p>1、"Vae+"帐号的所有权归太乐文化所有，用户完成申请注册手续后，获得"Vae+"帐号的使用权，该使用权仅属于初始申请注册人，禁止赠与、借用、租用、转让或售卖。太乐文化因经营需要，有权回收用户的"Vae+"帐号。
                            <br />
                            2、用户有责任妥善保管注册帐号信息及帐号密码的安全，因用户保管不善可能导致遭受盗号或密码失窃，责任由用户自行承担。用户需要对注册帐号以及密码下的行为承担法律责任。用户同意在任何情况下不使用其他用户的帐号或密码。在用户怀疑他人使用其帐号或密码时，用户同意立即通知太乐文化。
                            <br />
                            3、用户应遵守本协议的各项条款，正确、适当地使用本服务，如因用户违反本协议中的任何条款，太乐文化在通知用户后有权依据协议中断或终止对违约用户"Vae+"帐号提供服务。同时，太乐文化保留在任何时候收回"Vae+"帐号、用户名的权利。
                            <br />
                            4、您可通过第三方支付账户的方式在“Vae+”平台购买松果，并通过松果进行其他虚拟道具的购买及消耗。您对购买过程中发出指令的真实性及有效性承担责任，如无相反证据，指令一经发出不可撤销。基于虚拟货币的特殊性和法律规定，松果不得用于“Vae+”平台之外的用途。
                            <br />
                            5、您需知晓，注销账号是不可逆的行为，一旦您注销账号，“Vae+”平台将删除有关您账户的信息且默认您主动放弃账号中的所有资产，比如帖子、松果、积分等将会被删除且无法找回。若您注销账户再重新注册，原有账户信息也将无法恢复。
                            <br /> 6、您需知晓，若您账号因违反平台协议而被永久封禁，您将无法再使用该账号，并且您账号上的松果将全部扣除，“Vae+”平台亦不予退、换及兑换人民币的方式返还您购买松果的现金价值。
                            <br /> 7、若您在平台内上传、发布、传播或以其他方式传送的内容涉及反动、淫秽色情、赌博、吸毒、暴力、恐怖等信息，平台有权对账号进行删帖处理，情节严重者可对账号采取永久封禁的处理。
                            <br />
                            8、若您的账号涉及松果异常来源、虚拟道具异常交易，平台有权对异常来源的松果进行全部扣除、终止该账号虚拟道具交易订单，情节严重者可对账号进行永久封禁处理。前述所称异常来源包括但不限于：以违反平台规则、利用系统或规则漏洞、使用外挂或其他作弊程序等不正当方式直接或间接地对松果进行充值、获取、以及其他虚拟道具交易等侵害平台其他用户利益的行为。
                        </p>
                        <p>七、数据储存 </p>
                        <p> 1、太乐文化不对用户在本服务中相关数据的删除或储存失败负责。
                            2、太乐文化可以根据实际情况自行决定用户在本服务中数据的最长储存期限，并在服务器上为其分配数据最大存储空间等。用户可根据自己的需要自行备份本服务中的相关数据。
                            3、如用户停止使用本服务或本服务终止，太乐文化可以从服务器上永久地删除用户的数据。本服务停止、终止后，太乐文化没有义务向用户返还任何数据。
                        </p>
                        <p>八、风险承担 </p>
                        <p>1、用户理解并同意，"Vae+"仅为用户提供信息分享、传送及获取的平台，用户必须为自己注册帐号下的一切行为负责，包括用户所传送的任何内容以及由此产生的任何后果。用户应对"Vae+"及本服务中的内容自行加以判断，并承担因使用内容而引起的所有风险，包括因对内容的正确性、完整性或实用性的依赖而产生的风险。太乐文化无法且不会对因用户行为而导致的任何损失或损害承担责任。
                            <br /> 如果用户发现任何人违反本协议约定或以其他不当的方式使用本服务，请立即向太乐文化举报或投诉，太乐文化将依本协议约定进行处理。
                            <br /> 2、用户理解并同意，因业务发展需要，太乐文化保留单方面对本服务的全部或部分服务内容变更、暂停、终止或撤销的权利，用户需承担此风险。
                        </p>
                        <p>九、知识产权声明 </p>
                        <p>1、除本服务中涉及广告的知识产权由相应广告商享有外，太乐文化在本服务中提供的内容（包括但不限于网页、文字、图片、音频、视频、图表等）的知识产权均归太乐文化所有，但用户在使用本服务前对自己发布的内容已合法取得知识产权的除外。
                            <br /> 2、除另有特别声明外，太乐文化提供本服务时所依托软件的著作权、专利权及其他知识产权均归太乐文化所有。
                            <br />
                            3、太乐文化在本服务中所涉及的图形、文字或其组成，以及其他太乐文化标志及产品、服务名称（以下统称"太乐文化标识"），其著作权或商标权归太乐文化所有。未经太乐文化事先书面同意，用户不得将太乐文化标识以任何方式展示或使用或作其他处理，也不得向他人表明用户有权展示、使用、或其他有权处理太乐文化标识的行为。
                            <br /> 4、上述及其他任何太乐文化或相关广告商依法拥有的知识产权均受到法律保护，未经太乐文化或相关广告商书面许可，用户不得以任何形式进行使用或创造相关衍生作品。
                        </p>
                        <p>十、法律责任</p>
                        <p> 1、如果太乐文化发现或收到他人举报或投诉用户违反本协议约定的，太乐文化有权不经通知随时对相关内容，包括但不限于用户资料、聊天记录进行审查、删除，并视情节轻重对违规帐号处以包括但不限于警告、帐号封禁
                            、设备封禁 、功能封禁 的处罚，且通知用户处理结果。
                            <br /> 2、因违反用户协议被封禁的用户会在封禁期届满后自动恢复被封禁功能，另外被封禁用户可向太乐文化网站相关页面提交申诉，太乐文化将对申诉进行审查，并自行合理判断决定是否变更处罚措施。
                            <br />
                            3、用户理解并同意，太乐文化有权依合理判断对违反有关法律法规或本协议规定的行为进行处罚，对违法违规的任何用户采取适当的法律行动，并依据法律法规保存有关信息向有关部门报告等，用户应承担由此而产生的一切法律责任。
                            <br /> 4、用户理解并同意，因用户违反本协议约定，导致或产生的任何第三方主张的任何索赔、要求或损失，包括合理的律师费，用户应当赔偿太乐文化与合作公司、关联公司，并使之免受损害。
                        </p>
                        <p>十一、不可抗力及其他免责事由 </p>
                        <p>1、用户理解并确认，在使用本服务的过程中，可能会遇到不可抗力等风险因素，使本服务发生中断。不可抗力是指不能预见、不能克服并不能避免且对一方或双方造成重大影响的客观事件，包括但不限于自然灾害如洪水、地震、瘟疫流行和风暴等以及社会事件如战争、动乱、政府行为等。出现上述情况时，太乐文化将努力在第一时间与相关单位配合，及时进行修复，但是由此给用户或第三方造成的损失，太乐文化及合作单位在法律允许的范围内免责。
                            <br />
                            2、本服务同大多数互联网服务一样，受包括但不限于用户原因、网络服务质量、社会环境等因素的差异影响，可能受到各种安全问题的侵扰，如他人利用用户的资料，造成现实生活中的骚扰；用户下载安装的其它软件或访问的其他网站中含有"特洛伊木马"等病毒，威胁到用户的计算机信息和数据的安全，继而影响本服务的正常使用等等。用户应加强信息安全及使用者资料的保护意识，要注意加强密码保护，以免遭致损失和骚扰。
                            <br />
                            3、用户理解并确认，本服务存在因不可抗力、计算机病毒或黑客攻击、系统不稳定、用户所在位置、用户关机以及其他任何技术、互联网络、通信线路原因等造成的服务中断或不能满足用户要求的风险，因此导致的用户或第三方任何损失，太乐文化不承担任何责任。
                            <br />
                            4、用户理解并确认，在使用本服务过程中存在来自任何他人的包括误导性的、欺骗性的、威胁性的、诽谤性的、令人反感的或非法的信息，或侵犯他人权利的匿名或冒名的信息，以及伴随该等信息的行为，因此导致的用户或第三方的任何损失，太乐文化不承担任何责任。
                            <br />
                            5、用户理解并确认，太乐文化需要定期或不定期地对"Vae+"平台或相关的设备进行检修或者维护，如因此类情况而造成服务在合理时间内的中断，太乐文化无需为此承担任何责任，但太乐文化应事先进行通告。
                            <br /> 6、太乐文化依据法律法规、本协议约定获得处理违法违规或违约内容的权利，该权利不构成太乐文化的义务或承诺，太乐文化不能保证及时发现违法违规或违约行为或进行相应处理。
                            <br /> 7、用户理解并确认，对于太乐文化向用户提供的下列产品或者服务的质量缺陷及其引发的任何损失，太乐文化无需承担任何责任：
                            <br /> (1) 太乐文化向用户免费提供的服务；
                            <br /> (2) 太乐文化向用户赠送的任何产品或者服务。
                            <br />
                            8、在任何情况下，太乐文化均不对任何间接性、后果性、惩罚性、偶然性、特殊性或刑罚性的损害，包括因用户使用"Vae+"或本服务而遭受的利润损失，承担责任（即使太乐文化已被告知该等损失的可能性亦然）。尽管本协议中可能含有相悖的规定，太乐文化对用户承担的全部责任，无论因何原因或何种行为方式，始终不超过用户因使用太乐文化提供的服务而支付给太乐文化的费用(如有)。
                        </p>
                        <p>十二、服务的变更、中断、终止 </p>
                        <p>1、鉴于网络服务的特殊性，用户同意太乐文化有权随时变更、中断或终止部分或全部的服务。太乐文化变更、中断或终止的服务，太乐文化应当在变更、中断或终止之前通知用户，并应向受影响的用户提供等值的替代性的服务。
                            <br /> 2、如发生下列任何一种情形，太乐文化有权变更、中断或终止向用户提供的服务，而无需对用户或任何第三方承担任何责任：
                            <br /> (1) 根据法律规定用户应提交真实信息，而用户提供的个人资料不真实、或与注册时信息不一致又未能提供合理证明；
                            <br /> (2) 用户违反相关法律法规或本协议的约定；
                            <br />(3) 按照法律规定或有权机关的要求；
                            <br /> (4) 出于安全的原因或其他必要的情形。
                        </p>
                        <p>十三、其他 </p>
                        <p> 1、太乐文化郑重提醒用户注意本协议中免除太乐文化责任和限制用户权利的条款，请用户仔细阅读，自主考虑风险。未成年人应在法定监护人的陪同下阅读本协议。
                            <br />
                            2、本协议的效力、解释及纠纷的解决，适用于中华人民共和国法律。若用户和太乐文化之间发生任何纠纷或争议，首先应友好协商解决，协商不成的，用户同意将纠纷或争议提交太乐文化住所地有管辖权的人民法院管辖。
                            <br /> 3、本协议的任何条款无论因何种原因无效或不具可执行性，其余条款仍有效，对双方具有约束力。
                        </p>
                    </template>
                    <template v-if="menuIndex == 8">
                        <h2>隐私政策</h2>
                        <p>深圳太乐文化科技有限公司非常视用户的个人隐私保护，为切实保护Vae+用户隐私权益，优化用户体验，我们根据现行法规及政策，制定本个人信息隐私保护政策。本个人信息隐私保护政策将详细说明Vae+运营方在获取、管理及保护用户个人信息方面的政策及措施。本个人信息隐私保护政策适用于Vae+运营方向您提供的所有服务。
                        </p>
                        <p>本个人信息隐私保护政策是您使用Vae+服务及各项功能的基础性文件，我们希望您在使用Vae+服务前仔细阅读并明确您已经充分理解、接受本政策的内容，希望您可以根据自己的理解做出合适的选择。我们努力通过通俗的语言表述本个人信息隐私保护政策中涉及的相关术语，并提供进一步说明的链接，以便您更好地理解。在我们更新本个人信息隐私保护政策后您继续使用我们的产品与/或服务，即意味着您同意本个人信息隐私保护政策(含更新版本)内容，并且同意我们按照本个人信息隐私保护政策收集、使用、保存和共享您的相关信息。
                        </p>
                        <p>个人信息隐私保护政策涉及的个人信息包括：基本信息（包括个人姓名、生日、性别、住址、个人电话号码、电子邮箱）；个人身份信息（包括身份证、军官证、护照、驾驶证、相关身份证明等）；个人位置信息；网络身份标识信息（包括系统帐号、IP地址、邮箱地址及与前述有关的密码、密保）；通讯录；个人上网记录（包括搜索记录、软件使用记录、点击记录）；个人常用设备信息（包括硬件型号、设备MAC地址、操作系统类型、软件列表唯一设备识别码（如IMEI/android
                            ID/IDFA/OPENUDID/GUID、SIM卡IMSI信息等在内的描述个人常用设备基本情况的信息）；</p>
                        <p>个人敏感信息是指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息，本个人信息隐私保护政策中涉及的个人敏感信息包括：个人身份信息（包括身份证、军官证、护照、驾驶证、户口本）；网络身份识别信息（包括账户名、账户昵称、邮箱地址及与前述有关的密码与密码保护问题和答案）；其他信息（包括通讯录、个人电话号码、手机号码、行程信息、网页浏览记录、精准定位信息、银行账户）；相关身份证明；
                        </p>
                        <h3>个人信息的收集</h3>
                        <p>您已知悉且同意，在您注册Vae+帐号或使用Vae+提供的服务时，Vae+运营方将记录您提供的相关个人信息，如：密码、手机号码等，上述个人信息是您获得Vae+运营方提供服务的基础。同时，基于优化用户体验之目的，Vae+运营方会获取与提升Vae+服务有关的其他信息，例如当您访问Vae+时，我们可能会收集哪些服务的受欢迎程度、浏览器软件信息等以便优化我们的服务。
                            在您使用Vae+前，我们会引导您阅读本协议，并在您接受本协议的基础上，获得您的相关个人信息。如果您不同意提供个人信息，您将无法使用Vae+的的部分功能，或无法收到我们的通知等。
                        </p>
                        <p>Vae+运营方仅会在出现下列情况时收集您的个人信息：
                        </p>
                        <p>在您注册Vae+帐号时，我们至少会收集您的帐户昵称、性别、密码、手机号码等信息。若您以其他方式关联登录Vae+，我们会向关联第三方请求您的个人信息，对于我们要求但第三方无法提供的个人信息，我们仍可以要求您提供。如果您拒绝提供这些信息，将影响您使用Vae+或Vae+的相关功能。在您注册使用Vae+时，我们可能会对您进行实名验证，如果您拒绝提供有关信息，Vae+运营方将拒绝向您提供服务。
                        </p>
                        <p>在您发送Vae+、使用Vae+提供的位置定位服务时，我们会收集您的位置信息、设备信息等。Vae+运营方保证在您的设备使用定位服务时不会收集其他无关信息。
                        </p>
                        <p>在您使用Vae+运营方提供的搜索服务时，我们会收集您的查询关键字信息、设备信息等，为了提供高效的搜索服务，这些信息有部分会暂时存储在您的本地存储设备之中。在此，您需要注意的是，您的关键词信息无法单独识别您的个人身份，其不属于您的个人信息，因此我们有权以其他的目的对其进行使用；只有当您的搜索关键词信息与您的其他信息互有联系并可以识别您的个人身份时，则在结合使用期间，我们会将您的搜索关键词信息作为您的个人信息，与您的搜索历史记录一同按照本个人信息隐私保护政策对其进行处理与保护。
                        </p>
                        <p>在您使用Vae+运营方提供的身份认证服务时，我们会收集您的姓名、身份证号、有关身份证明等信息，Vae+运营方对您的这些隐私信息会加以最大程度的保护，如果您不提供这些信息，我们将无法提供相关服务。
                        </p>
                        <p>当您参加Vae+的有关活动时，我们会收集您的姓名、通讯地址、联系方式、银行帐号等信息。这些信息是您收到转账或礼品的基础，如果您拒绝提供这些信息，我们将无法向您转账或发放礼品。
                        </p>
                        <p>当您在Vae+中使用第三方提供的服务时，Vae+运营方视为您允许第三方收集您的基本信息、网络身份标识信息等，如果您拒绝第三方在提供服务时收集此类信息，将可能会导致您无法在Vae+中使用第三方服务。
                        </p>
                        <p>基于对您信息的有效保护并且在您同意的基础上，我们会对收集到的您的信息进行去标签化处理，以保护您的信息安全。在此希望您了解并接受在不透露您个人信息的前提下，Vae+运营方有权对您的信息进行分析并予以商业化的利用。
                        </p>
                        <p>当涉及国家安全与利益、社会公共利益、与犯罪侦查有关的相关活动、您或他人生命财产安全但在特殊情况下无法获得您的及时授权、能够从其他合法公开的渠道、法律法规规定的其他情形下，Vae+运营方可能在不经过您的同意或授权的前提下，收集您的个人信息。
                        </p>
                        <p>在某些特殊情况下，Vae+运营方会要求您提供相关证明等纸质版信息。在Vae+运营方收到您的纸质版信息的30天内，Vae+运营方会妥善处理您的信息并及时告知您。
                        </p>
                        <p>另，如在上述场景之外获得您的个人信息，将重新征得您的明示同意，并在获得您明示同意前向您充分说明应用场景与获取您相关信息的内容与范围。
                        </p>
                        <p>为了向您提供更好的服务或产品，Vae+运营方会在下述情形使用您的个人信息：
                            <br /> 1)、 根据相关法律法规的要求；
                            <br />2)、 根据您的授权；
                            <br />3)、 根据Vae+相关服务条款、应用许可使用协议的约定。
                        </p>
                        <p>此外，您已知悉并同意：在现行法律法规允许的范围内，Vae+运营方可能会将您非敏感的个人信息用于市场营销，使用方式包括但不限于：Vae+运营方会使用您所提供信息在Vae+平台中向您展示、通告或推荐Vae+的服务或产品信息，以及其他此类根据您使用Vae+服务或产品的情况所认为您可能会感兴趣的信息。其中也包括您在采取授权等某动作时选择分享的信息。
                            Vae+会在用户使用应用的过程中获取相关权限，提供给用户更好的体验，并保证用户在授权过程当中知晓授权详情，且用户有足够的权利选择同意或拒绝授权；获取权限后，Vae+不会将任何通过权限获取到的内容外泄，保证用户在清晰知晓当前情况下进行权限授权操作，保障用户的数据安全。
                            <br />1)、 获取相机及相册权限，用于发布动态和状态中的图片与视频；
                            <br />2)、 获取大致和确切地理位置，用于发布动态中用户可添加位置信息；
                            <br /> 3)、 获取录制音频和麦克风权限，用于用户之间可发语音消息；
                            <br /> 4)、 获取设备识别码和状态，用于识别设备唯一性，保证用户的帐号及隐私安全；
                            <br /> 5)、 读取或修改SD卡或其他存储器中的内容，用于用户的图片及消息保存。
                        </p>
                        <h3>个人信息的保护和安全措施</h3>
                        <p>Vae+运营方将尽一切合理努力保护其获得的用户个人信息，并由专门的数据安全部门对个人信息进行保护。为防止用户个人信息在意外的、未经授权的情况下被非法访问、复制、修改、传送、遗失、破坏、处理或使用，Vae+运营方已经并将继续采取以下措施保护您的个人信息：
                        </p>
                        <p>1、Soda运营方采取的安全措施
                            <br />1)、 我们的网络服务采取了传输层安全协议等加密技术，通过https等方式提供浏览服务，确保用户数据在传输过程中的安全。
                            <br />2)、 通过采取加密技术对用户个人信息进行加密保存，并通过隔离技术进行隔离。
                            <br /> 3)、 在个人信息使用时，例如个人信息展示、个人信息关联计算，我们会采用包括内容替换、加密脱敏等多种数据脱敏技术增强个人信息在使用中安全性。
                            <br />4)、 设立严格的数据使用和访问制度，采用严格的数据访问权限控制和多重身份认证技术保护个人信息，避免数据被违规使用。
                            <br />5)、 采取专门的数据和技术安全审计，设立日志审计和行为审计多项措施。
                        </p>
                        <p>2、保护个人信息采取的其他安全措施
                            <br />1)、 通过建立数据分类分级制度、数据安全管理规范、数据安全开发规范来管理规范个人信息的存储和使用。
                            <br />2)、 建立数据安全专项部门，负责安全应急响应组织来推进和保障个人信息安全。
                            <br />3)、 加强安全意识。我们还会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。
                        </p>
                        <p>3、个人信息安全事件的通知
                            <br /> 1)、 如发生个人信息引发的安全事件，Vae+运营方将第一事件向相应主管机关报备，并即时进行问题排查，开展应急措施。
                            <br /> 2)、 通过与全量用户发送通知提醒更改密码。还可能通过电话、短信等各种方式触达用户知晓，在Vae+公共运营平台运营宣传，制止数据泄露。
                        </p>
                        <p>尽管已经采取了上述合理有效措施，并已经遵守了相关法律规定要求的标准，但Vae+运营方仍然无法保证您的个人信息通过不安全途径进行交流时的安全性。因此，用户个人应采取积极措施保证个人信息的安全，如：定期修改帐号密码，不将自己的帐号密码等个人信息透露给他人。
                        </p>
                        <p>您知悉：Vae+运营方提供的个人信息隐私保护措施仅适用于Vae+平台，一旦您离开Vae+，浏览或使用其他网站、服务及内容资源，Vae+运营方即没有能力及义务保护您在Vae+以外的网站提交的任何个人信息，无论您登录或浏览上述网站是否基于Vae+的链接或引导。
                        </p>
                        <p>网络环境中始终存在各种信息泄漏的风险，当出现意外事件、不可抗力等情形导致您的信息出现泄漏时，Vae+运营方将极力控制局面，及时告知您事件起因、Vae+运营方采取的安全措施、您可以主动采取的安全措施等相关情况。
                        </p>
                        <h3>个人信息的存储</h3>
                        <p>Vae+运营方会采取合适的安全措施和技术手段存储及保护您的个人信息，以防止丢失、被误用、受到未授权访问或泄漏、被篡改或毁坏。您的个人信息存放在有密码控制的位于中国境内的服务器中，访问均是受到限制的。当您需要跨境信息传输服务时，Vae+运营方会默认您继续使用中国境内的服务器。
                        </p>
                        <p>Vae+运营方会依照个人信息的不同等级存储不同期限，存储期限严格按照法律及相关法规规定，最低期限不少于6个月。
                        </p>
                        <p>根据本条款的规定，我们仅允许有必要知晓这些信息的Vae+运营方员工等第三方访问个人信息，并要求他们履行相应的保密义务。

                        </p>
                        <p>Vae+运营方如涉及向境外传输个人信息，将会向用户明确告知并征得同意。
                        </p>
                        <h3>个人信息的使用和对外提供</h3>
                        <p>未经您本人允许，Vae+运营方不会向任何第三方公开（包括共享、转让、公开披露等方式）您的个人信息，下列情形除外：
                            <br />1)、 Vae+运营方已经取得您或您监护人的授权或同意；
                            <br />2)、 司法机关或行政机关基于法定程序要求Vae+运营方披露的；
                            <br />3)、 Vae+运营方为维护自身合法权益而向用户提起诉讼或仲裁时；
                            <br />4)、 根据您与Vae+相关服务条款、应用许可使用协议的约定；
                            <br />5)、 在法律允许的范围内，为保障Vae+、Vae+用户以及社会公共利益免受损害时；
                            <br />6)、 符合您与其他第三人之间有关约定的；
                        </p>
                        <p>您可以向特定的对象发送您的照片、身份信息、位置信息等，也可以基于Vae+的服务向不特定人共享自己的照片、位置信息、身份信息等。当您因为您的共享行为导致您的信息发生泄漏等严重情况时，Vae+运营方不承担相关法律责任。
                        </p>
                        <p>随着我们业务的发展，我们及我们的关联方有可能进行合并、收购、资产转让或类似的交易，您的个人信息有可能作为此类交易的一部分而被转移。我们将在转移前通知您。
                        </p>
                        <h3>个人信息的管理</h3>
                        <p>当您完成Vae+的帐号注册并进行合理和必要的身份验证后，您可以查阅、修改、删除您提交给Vae+运营方的个人信息。一般情况下，您可随时浏览、修改、删除自己提交的信息，但出于安全性和身份识别的考虑，您可能无法修改注册时提供的某些初始注册信息及验证信息。
                        </p>
                        <p>Vae+运营方始终将对您个人信息的保护放在首位，同时，Vae+运营方重视您对个人信息的关注。对于您的个人信息，您可以通过手机客户端途径在线查询、修改、删除您的个人信息。
                        </p>
                        <p>您有权自主更新或更正您的个人信息，或授权Vae+客服进行信息更新、更正。在您进行信息更新更正之前，我们会首先验证您的身份，其次才能进行信息的更正与更新。
                        </p>
                        <p>如果您对本个人信息隐私保护政策或其中有关您个人信息的收集、使用、存储、保护等功能存在意见或建议时，您可以通过Vae+功能页面、或Vae+官方管理帐号反馈意见或投诉，Vae+运营方会在收到您意见及建议的第一时间将反馈信息回复给您。
                        </p>
                        <p>您可以通过关闭Vae+部分功能的方式阻止Vae+运营方获得您的个人信息，关闭部分功能之后，我们将无法向您提供相应的服务。
                        </p>
                        <p>如果我们终止服务或运营，我们会至少提前三十日向您通知，并在终止服务或运营后对您的个人信息进行删除或匿名化处理。
                        </p>
                        <h3>个人账号的注销</h3>
                        <p>您可以通过点击“我的”-“设置”-“安全设置”-“注销账号”，向我们提出注销您已注册的Vae+账号请求，我们会在核实您的个人身份信息及确认您满足注销条件后为您注销账号。
                        </p>
                        <p>请您知悉，在注销账号后，除非根据法律法规或根据监管部门的要求保留或存储您的个人信息，否则我们将及时删除您的个人信息或作匿名化处理。
                        </p>
                        <p>您注销账号的行为是不可逆的，一旦您的账号被注销，我们将不再收集您的个人信息，但同时也请您理解，我们无法再为您提供与之对应的服务。因此建议您谨慎选择注销账号。
                        </p>
                        <h3>对未成年人个人信息的特别保护</h3>
                        <p>
                            Vae+运营方非常重视对未成年人个人信息的保护。若您是14周岁以下的未成年人，在使用Vae+运营方的服务前，应确保事先取得监护人的同意，如果您是已满14不满18岁的未成年人，在使用Vae+运营方服务前，应确保事先取得本人或监护人的同意。对未满18周岁的未成年人，Vae+运营方不提供充值服务。如您在Vae+上申请注册帐号，Vae+运营方将默认为您已得到前述同意。Vae+运营方将根据国家相关法律法规及本《个人信息隐私保护政策》的规定保护未成年人的个人信息。
                        </p>
                        <h3>个人信息隐私保护政策的修改</h3>
                        <p>1、为给您提供更好的服务以及随着我们业务的发展，本个人信息隐私保护政策也会随之更新。但未经您明确同意，我们不会削减您依据当前生效个人信息隐私保护政策所应享有的权利。
                            我们会通过在网站、移动端上发出更新版本并在生效前通过网站公告或以其他适当方式提醒您相关内容的更新，以便及时了解最新的个人信息隐私保护政策。
                        </p>
                        <p>2、对于重大变更，我们还会提供更为显著的通知（我们会通过包括但不限于邮件、短信、私信或在浏览页面做特别提示等方式，说明个人信息隐私保护政策的具体变更内容）。
                            本政策所指的重大变更包括但不限于：
                            <br />1)、 我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；
                            <br />2)、 我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；
                            <br />3)、 个人信息共享、转让或公开披露的主要对象发生变化；
                            <br />4)、 您参与个人信息处理方面的权利及其行使方式发生重大变化；
                            <br />5)、 我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；
                            <br />6)、 个人信息安全影响评估报告表明存在高风险时。
                        </p>
                        <h3>联系我们</h3>
                        <p>对于本个人信息隐私保护政策有任何疑问，可以通过以下方式与Vae+联系：</p>
                        <p>公司名称：深圳太乐文化科技有限公司</p>
                        <p>注册地址：深圳市南山区粤海街道高新区社区高新南九道51号航空航天大厦1号楼3层3305</p>
                        <p>联系邮箱：<a href="mailto:chenyu@taihe.com">chenyu@taihe.com</a></p>
                        <p>联系地址：北京市朝阳区三里屯西五街五号院C座太合音乐</p>
                        <p>联系电话：<a href="tel:15820039457">15820039457</a></p>
                        <p>联系人：Vae+陈知遇</p>
                        <p>我们将于收到你的意见后尽快完成审核，并于验证你的用户身份后15个工作日内予以回复。</p>
                        <h3>附：第三方协议使用列表</h3>
                        <table>
                            <thead>
                                <tr>
                                    <th>SDK名称</th>
                                    <th>使用目的</th>
                                    <th>收集数据类型</th>
                                    <th>官网链接</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Amap_Location高德定位</td>
                                    <td>帮助用户发布信息时定位位置、现场签到、查询附近人</td>
                                    <td>设备识别信息、地理位置信息</td>
                                    <td>https://maplab.amap.com/</td>
                                </tr>
                                <tr>
                                    <td>Amap_Search高德地图</td>
                                    <td>帮助用户发布信息时定位位置、现场签到、查询附近人</td>
                                    <td>设备识别信息、地理位置信息</td>
                                    <td>https://maplab.amap.com/</td>
                                </tr>
                                <tr>
                                    <td>AlipaySDK</td>
                                    <td>支付使用</td>
                                    <td>设备识别信息</td>
                                    <td>https://open.alipay.com/platform/home.htm</td>
                                </tr>
                                <tr>
                                    <td>weiboSDK微博</td>
                                    <td>微博分享、登录</td>
                                    <td>设备识别信息</td>
                                    <td>https://open.weibo.com/wiki/SDK</td>
                                </tr>
                                <tr>
                                    <td>WeChatSDK微信SDK</td>
                                    <td>微信分享、登录、支付</td>
                                    <td>设备识别信息</td>
                                    <td>https://open.weixin.qq.com/</td>
                                </tr>
                                <tr>
                                    <td>qqopensdk QQ官方SDK</td>
                                    <td>QQ登录、分享</td>
                                    <td>设备识别信息</td>
                                    <td>https://connect.qq.com/</td>
                                </tr>
                                <tr>
                                    <td>TcIM 腾讯IM</td>
                                    <td>用户聊天、群组</td>
                                    <td>设备识别信息</td>
                                    <td>https://cloud.tencent.com/document/product/269</td>
                                </tr>
                                <tr>
                                    <td>TUSDK</td>
                                    <td>短视频编辑</td>
                                    <td>设备识别信息</td>
                                    <td>https://tutucloud.com/</td>
                                </tr>
                                <tr>
                                    <td>腾讯移动直播SDK</td>
                                    <td>直播</td>
                                    <td>设备识别信息</td>
                                    <td>https://cloud.tencent.com/document/product/454</td>
                                </tr>
                                <tr>
                                    <td>sobotsdk_x 智齿SDK</td>
                                    <td>客服</td>
                                    <td>设备识别信息</td>
                                    <td>http://static.sobot.com/helpcenter/chapter1/android-sdk-jie-ru.html</td>
                                </tr>
                                <tr>
                                    <td>Jpush 极光SDK</td>
                                    <td>信息推送</td>
                                    <td>设备唯一标识信息、访问手机状态</td>
                                    <td>https://www.jiguang.cn/push?source=bdpc&plan=24&unit=313&keyword=17172</td>
                                </tr>
                                <tr>
                                    <td>腾讯Bugly</td>
                                    <td>错误检测</td>
                                    <td>设备识别信息、手机日志信息</td>
                                    <td>https://bugly.qq.com/v2/workbench/apps</td>
                                </tr>
                            </tbody>
                        </table>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            menuIndex: 0,
            menus: ['平台介绍', '联系我们', '平台管理制度', '纠纷处理制度', '内容审核制度', '未成年人保护制度',
                'VIP会员退款', '服务条款', '隐私政策']
        }
    },
    mounted() {
        const { index } = this.$route.query;
        if (index) this.menuIndex = index;
    }
}
</script>

<style lang="scss">
.help-content {
    width: 1000px;
    margin: 0px auto;
    padding: 20px 0;
    display: flex;

    .menu {
        width: 250px;
        background: #FFFFFF;
        border-radius: 10px;
        padding: 40px 0px;
        overflow: auto;

        li {
            line-height: 34px;
            padding: 0 30px;
            font-size: 14px;
            font-weight: 600;
            color: #666;
            margin: 10px 0;
            border-left: 3px solid #fff;
            cursor: pointer;

            &.active {
                color: #000;
                border-left: 3px solid #6CA6FF;
            }
        }
    }

    .content {
        background: #FFFFFF;
        border-radius: 10px;
        padding: 40px 30px;
        margin-left: 20px;
        flex: 1;
        max-height: 740px;
        overflow: auto;

        p {
            font-size: 14px;
            font-weight: 400;
            line-height: 24px;
            margin-bottom: 20px;
            color: #555555;
        }

        h2 {
            font-size: 18px;
            font-weight: 600;
            color: #000000;
            line-height: 18px;
            margin-bottom: 20px;
        }

        br {
            margin-bottom: 10px;
        }

        table {
            border-top: 1px solid #d4d4d4;
            border-left: 1px solid #d4d4d4;
            border-collapse: collapse;

            td,
            th {
                padding: 5px 10px;
                border-right: 1px solid #d4d4d4;
                border-bottom: 1px solid #d4d4d4;
                color: #555555;
                font-size: 13px;
            }

            th {
                color: #000000;
                background-color: #f2f2f2;
            }

        }
    }
}
</style>
